/**
 * Portable Appliance Testing (PAT) - Default Blank State
 */

const today = new Date().toISOString().split('T')[0];

export default {
  jobDetails: {
    certificateNumber: `PAT-${Date.now()}`,
    testDate: today,
    dutyHolder: '',
    testLocation: '',
    companyName: '',
    engineerName: '',
    engineerCardNumber: ''
  },
  testEquipment: [
    {
      equipmentMake: '',
      equipmentModel: '',
      equipmentSerial: '',
      calibrationDate: '',
      calibrationDue: ''
    }
  ],
  appliances: [
    {
      itemId: '1',
      description: '',
      applianceClass: '',
      visualInspection: '',
      earthContinuity: '',
      leadResistance: '',
      insulationResistance: '',
      touchLeakage: '',
      testResult: '',
      retestPeriod: '',
      notes: ''
    }
  ],
  declaration: {
    engineerSignature: '',
    customerSignature: ''
  }
};